export default "__VITE_ASSET__Bj0PL5wI__"